import { all, call, fork, put, takeLatest } from "@redux-saga/core/effects";
import { message } from "antd";
import { FETCH_RELEASEDS_REQUEST } from "constants/Released";
import { fetchReleasedsFailure, fetchReleasedsSuccess } from "redux/actions/Released";
import ReleasedService from "services/Released";

export function* onFetchReleaseds() {
  yield takeLatest(FETCH_RELEASEDS_REQUEST, function* (payload) {
    try {
      const result = yield call(ReleasedService.index, payload.payload);
      if (result.status) {
        yield put(fetchReleasedsSuccess(result.data));
      } else {
        yield put(fetchReleasedsFailure(result.message));
      }
    } catch (error) {
      yield put(fetchReleasedsFailure(error.message));
    }
  });
}

export default function* rootSaga() {
  yield all([fork(onFetchReleaseds)]);
}
